import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import { REFERRAL_HISTORY_TAB, MINIMUM_SHOWN_ITEM } from '../const'
import ReferralHistoryIncompleteInfo from './incomplete-info'
import ReferralHistoryOrderPiece from './piece'
import styles from './styles.scss'

const ReferralHistoryListSection = ({ orderList, selectedTab, t }) => {
  const isCollapse =
    orderList.length > MINIMUM_SHOWN_ITEM &&
    [
      REFERRAL_HISTORY_TAB.IN_PROGRESS,
      REFERRAL_HISTORY_TAB.IN_COMPLETE,
    ].includes(selectedTab)
  const [displayOrderNumber, setDisplayOrderNumber] =
    useState(MINIMUM_SHOWN_ITEM)
  const [displayOrderList, setDisplayOrderList] = useState([])
  const isMoreOrderToDisply = displayOrderList.length < orderList.length
  const collapseButtonText = t(isMoreOrderToDisply ? 'SHOW MORE' : 'SHOW LESS')
  const showMoreOrder = () => {
    setDisplayOrderNumber((num) => num + MINIMUM_SHOWN_ITEM)
    orderList.slice(0, displayOrderNumber)
  }
  const showLessOrder = () => {
    setDisplayOrderNumber(MINIMUM_SHOWN_ITEM)
    orderList.slice(0, displayOrderNumber)
  }
  const handleClickButton = isMoreOrderToDisply ? showMoreOrder : showLessOrder

  useEffect(
    () =>
      setDisplayOrderList(
        isCollapse ? orderList.slice(0, displayOrderNumber) : orderList,
      ),
    [orderList, isCollapse, displayOrderNumber],
  )

  return (
    <div className="referral-history-list">
      <style jsx>{styles}</style>
      {selectedTab === REFERRAL_HISTORY_TAB.IN_COMPLETE && (
        <ReferralHistoryIncompleteInfo />
      )}
      {displayOrderList.map((order) => (
        <ReferralHistoryOrderPiece
          key={order.id_order}
          order={order}
          selectedTab={selectedTab}
        />
      ))}
      {isCollapse && (
        <Button
          className="referral-incomplete-list__cta"
          type={BUTTON_TYPES.link}
          onClick={handleClickButton}
        >
          {collapseButtonText}
        </Button>
      )}
    </div>
  )
}

ReferralHistoryListSection.propTypes = {
  orderList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedTab: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    selectedTab: state.referralHistory.selectedTab,
  })),
  withI18next(),
)(ReferralHistoryListSection)
